import './index.css';
import lefticon from '../../images/Leftnew.svg';
import eye from '../../images/eye1.svg';
import eyeOff from '../../images/eye1.svg';
import React, { useState } from 'react';

export default function NewPasswordPage() {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
        <div className='Login-container-bg'>
            <div className='Login-container-main'>
                <div className='setup-container-main'>
                    <div className='setup-icon-container'>
                        <img src={lefticon} alt="Left Icon" className='setup-icon' />
                    </div>
                    <h2 className='setup-title'>New Password</h2>
                    <p className='setup-description'>Create your new password to login</p>

                    {['NEW PASSWORD', 'CONFIRM PASSWORD'].map((label, index) => (
                        <div key={label} className="email-input-container">
                            <label className="email-label">{label}</label>
                            <div className="input-wrapper">
                                <input
                                    type={(index === 0 ? showNewPassword : showConfirmPassword) ? 'text' : 'password'}
                                    className="email-input"
                                    value={index === 0 ? newPassword : confirmPassword}
                                    onChange={(e) => index === 0 ? setNewPassword(e.target.value) : setConfirmPassword(e.target.value)}
                                />
                                <img
                                    src={(index === 0 ? showNewPassword : showConfirmPassword) ? eyeOff : eye}
                                    alt="Toggle Password Visibility"
                                    className="input-icon"
                                    onClick={() => index === 0 ? setShowNewPassword(!showNewPassword) : setShowConfirmPassword(!showConfirmPassword)}
                                />
                            </div>
                        </div>
                    ))}

                    <div className='login-button-container'>
                        <button>Create Password</button>
                    </div>
                </div>
            </div>
        </div>
    );
}